<template>
    <modal name="informacion-paciente-dashboard" height="700px" :clickToClose="false" style="border-radius: 10px;">
        <div>
            <div class="header-custom">
                <div>
                    <span>Información completa del paciente</span>
                </div>
                <div>
                    <button class="btn btn-simple btn-danger" @click="$modal.hide('informacion-paciente-dashboard')">
                        <i class="fa fa-close"></i>
                    </button>
                </div>
            </div>
            <div class="content-custom">
                <div class="paciente-information">
                    <div class="paciente-information-footer">
                        <img :src="url + paciente.foto" alt="foto paciente" width="100" height="100" style="border-radius: 10px; object-fit: cover;">
                        <h2>{{ paciente.nombres + ' ' + paciente.apellidos }}</h2>
                    </div>
                    <div class="paciente-information-content">
                        <div> 
                            <span style="font-weight: 500; font-size: 16px;"><i class="fa fa-user"></i> Identificación</span>
                        </div>
                        <div>
                            <br>
                            <span>Tipo de documento: {{ paciente.tipo_documento }}</span> <br>
                            <span>Número de documento: {{ paciente.documento }}</span>
                        </div>
                    </div>
                    <br>
                    <div class="paciente-information-content">
                        <div>
                            <span style="font-weight: 500; font-size: 16px;"><i class="fa fa-folder"></i> Afiliación </span>
                        </div>
                        <div>
                            <br>
                            <span>Regimen: {{ paciente.regimen == 1 ? 'Contributivo' : 'Subsidiado' }}</span> <br>
                            <span>EPS: {{ paciente.eps }}</span> <br>
                            <span>Prepagada: {{ paciente.prepagada }}</span> <br>
                            <span>Poliza: {{ paciente.poliza }}</span>
                        </div>
                    </div>
                    <br>
                    <div class="paciente-information-content">
                        <div>
                            <span style="font-weight: 500; font-size: 16px;"><i class="fa fa-phone"></i> Residencia y contacto</span>
                        </div>
                        <div>
                            <br>
                            <span>Teléfono: {{ paciente.telefono }}</span> <br>
                            <span>Dirección: {{ paciente.direccion }}</span> <br>
                            <span>Correo electrónico: {{ paciente.correo }}</span> <br>
                            <span>Nombre del acudiente: {{ paciente.acudiente }}</span> <br>
                            <span>Teléfono del acudiente: {{ paciente.numeroAcudiente }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
export default {
    props: {
        paciente: {},
    },
    data() {
        return {
            url: 'https://avanti-erp.com/',
        };
    }
};

</script>
<style>
.v--modal {
    border-radius: 10px !important;
}

.header-custom{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px ;
}

.content-custom{
    padding: 15px;
    height: 600px;
    overflow-y: scroll;
}

.paciente-information{
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
}

.paciente-information-footer{
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 10px;
}

.paciente-information-content{
    background-color: rgb(250, 250, 250);
    border-radius: 10px;
    padding: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/Reportes/modals/informacion-paciente.vue